


































import { Component, Prop, Vue } from 'vue-property-decorator'
import WarningIcon from '@/app/ui/assets/warning_icon.vue'
import DropdownSelect from '@/app/ui/components/DropdownSelect/index.vue'
import IconWarningTriangle from '@/app/ui/assets/icon_warning_triangles.vue'

@Component({
  inheritAttrs: false,
  components: {
    DropdownSelect,
    WarningIcon,
    IconWarningTriangle
  },
})
export default class VoucherDropdown extends Vue {
  @Prop({ required: true }) private fieldLabel!: string
  @Prop() private fieldDescription!: string
  @Prop() private errorMessage!: string
  @Prop({ default: false }) private isFailedLoadData!: boolean
  @Prop({ default: false }) private required!: boolean
}
